export const AvailableFiltersContact = [
  { id: 1, name: `name`, label: 'Name', extension: true, column: 1 },
  { id: 2, name: `dba`, label: 'DBA', extension: true, column: 1 },
  { id: 3, name: `mc_number`, label: 'MC Number', extension: true, column: 1 },
  { id: 4, name: `dot_number`, label: 'Dot Number', extension: true, column: 1 },
  { id: 5, name: `organization_type_id`, label: 'Organization Type', extension: true, column: 1 },
  { id: 6, name: `company_type_id`, label: 'Company Type', extension: true, column: 1 },
  { id: 7, name: `date_established`, label: 'Date Established', extension: true, column: 1 },
  { id: 8, name: `creation_date`, label: 'Date Entered', extension: true, column: 1 },
  { id: 9, name: `import_date`, label: 'Import Date', extension: true, column: 1 },
  { id: 10, name: `created_by`, label: 'Created By', extension: true, column: 1 },
  { id: 11, name: `source_id`, label: 'Source', extension: true, column: 1 },

  { id: 12, name: `number_of_trucks`, label: 'No. of Trucks', extension: true, column: 2 },
  { id: 13, name: `number_of_trailers`, label: 'No. of Trailers', extension: true, column: 2 },
  { id: 14, name: `number_of_drivers`, label: 'No. of Drivers', extension: true, column: 2 },
  { id: 15, name: `estimated_revenue`, label: 'Est. Revenue', extension: true, column: 2 },
  { id: 16, name: `effort_level`, label: 'Effort Level', extension: true, column: 2 }, // contact_division
  { id: 17, name: `grade`, label: 'Grade', extension: false, column: 2 }, // contact_division
  { id: 18, name: `operating_status`, label: 'Operating Status', extension: true, column: 2 },
  { id: 19, name: `operation_classification`, label: 'Operation Classification', extension: true, column: 2 },
  { id: 20, name: `authority_type`, label: 'Authority Type', extension: true, column: 2 },
  { id: 21, name: `carrier_operation`, label: 'Carrier Operation', extension: true, column: 2 },
  { id: 22, name: `cargo_carried`, label: 'Cargo Carried', extension: true, column: 2 },

  { id: 23, name: `owner_name`, label: 'Company Owner', extension: true, column: 3 },
  { id: 24, name: `nationality_id`, label: 'Preferred Language', extension: true, column: 3 },
  { id: 25, name: `business_phone`, label: 'Business Phone', extension: true, column: 3 },
  { id: 26, name: `email`, label: 'Email', extension: true, column: 3 },
  { id: 27, name: `address_city`, label: 'City', extension: true, column: 3 },
  { id: 28, name: `address_state`, label: 'State', extension: true, column: 3 },
  { id: 29, name: `address_zip`, label: 'Zip', extension: true, column: 3 },
  { id: 30, name: `distance`, label: 'Distance', extension: true, column: 3 },
  { id: 31, name: `salesperson`, label: 'Salesperson', extension: true, column: 3 },
  { id: 32, name: `last_contact_date`, label: 'Last Contact Date', extension: true, column: 3 },
  { id: 33, name: `prospect_date`, label: 'Prospect Date', extension: true, column: 3 }, // contact_division
  { id: 34, name: 'account_date', label: 'Account Date', extension: true, column: 3 },

  { id: 35, name: `red_flag`, label: 'Red Flag', extension: true, column: 4 },
  { id: 36, name: `insurance_company`, label: 'Insurance Company', extension: true, column: 4 },
  { id: 37, name: `exp_date`, label: 'Insurance Expiration', extension: true, column: 4 },
  { id: 38, name: `ucc_eff_date`, label: 'UCC Date', extension: true, column: 4 },
  { id: 39, name: `factoring_company`, label: 'Factoring Company', extension: true, column: 4 },
  { id: 40, name: `chameleon_type1`, label: 'Chameleon Type 1', extension: true, column: 4 },
  { id: 41, name: `chameleon_type2`, label: 'Chameleon Type 2', extension: true, column: 4 },
  { id: 42, name: `division_accounts`, label: 'Division Accounts', extension: true, column: 4 },

  // { id: 43, name: 'last_safer_update', label: 'Last Safer Update' },
  // { id: 44, name: `blacklist_phone`, label: 'Blacklist Phone', extension: true },
  // { id: 45, name: 'is_ex_yu', label: 'Ex-Yu', extension: true },
  // { id: 46, name: 'division_leads', label: 'Division Leads', extension: true },
]

export const AvailableFiltersMerchants = [
  { id: 1, name: 'name', label: 'Name' },
  { id: 2, name: 'owner_name', label: 'Company Owner' },
  { id: 3, name: 'merchant_type', label: 'Merchant Type' },
  { id: 4, name: 'address_state', label: 'State' },
  { id: 5, name: 'estimated_revenue', label: 'Est. Revenue' },
  { id: 6, name: 'date_established', label: 'Date Established' },
  { id: 7, name: 'created_by', label: 'Entered By' },
  { id: 9, name: 'divisions.division_id', label: 'Division Accounts' },
  { id: 11, name: 'out_of_business', label: 'Out Of Business' },
  { id: 12, name: 'email', label: 'Email' },
  { id: 13, name: 'business_phone', label: 'Business Phone' },
  { id: 14, name: 'source_id', label: 'Source' },
  { id: 15, name: 'address_zip', label: 'Zip Code' },
  { id: 16, name: 'divisions.grade', label: 'Grade' },
  { id: 17, name: 'merchant', label: 'Merchant' },
  { id: 18, name: 'import_date', label: 'Import Date' },
  { id: 19, name: 'creation_date', label: 'Date Entered' },
  { id: 20, name: 'divisions.assigned', label: 'Salesperson' },
]

export const AvailableFiltersCustomerLogistics = [
  { id: 1, name: 'name', label: 'Name' },
  { id: 2, name: 'business_phone', label: 'Business Phone' },
  { id: 3, name: 'source_id', label: 'Source' },
  { id: 22, name: 'nationality_id', label: 'Preferred Language' },
  { id: 23, name: 'address_city', label: 'City' },
  { id: 4, name: 'address_state', label: 'State' },
  { id: 5, name: 'annual_sales_id', label: 'Annual Sales' },
  { id: 6, name: 'date_established', label: 'Date Established' },
  { id: 7, name: 'creation_date', label: 'Date Entered' },
  { id: 8, name: 'equipment_type', label: 'Equipment Type' },
  { id: 9, name: 'load_cost', label: 'Load Cost' },
  { id: 10, name: 'destination', label: 'Destination' },
  { id: 11, name: 'salesperson', label: 'Salesperson' },
  { id: 12, name: 'email', label: 'Email' },
  { id: 13, name: 'last_contact_date', label: 'Last Contact Date' },
  { id: 14, name: 'address_zip', label: 'Zip Code' },
  { id: 15, name: 'grade', label: 'Grade' },
  { id: 16, name: 'created_by', label: 'Created By' },
  { id: 17, name: 'red_flag', label: 'Red Flag' },
  { id: 18, name: 'load_type', label: 'Load Type' },
  { id: 19, name: 'origin', label: 'Origin' },
  { id: 20, name: 'contact_person', label: 'Contact Person' },
  { id: 21, name: 'account_date', label: 'Account Date', extension: true },
  { id: 24, name: 'tms_type_id', label: 'TMS Type' },
  { id: 25, name: 'effort_level', label: 'Effort Level' },
  { id: 26, name: 'prospect_date', label: 'Prospect Date', extension: true },
  { id: 27, name: 'rfp_date', label: 'RFP Date', extension: true },
  { id: 28, name: 'pending_account_date', label: 'Pending Account Date', extension: true },
  { id: 29, name: 'dead_date', label: 'Dead Date', extension: true },
  { id: 30, name: 'nq_date', label: 'NQ Date', extension: true },
  { id: 31, name: 'i_give_up', label: 'I Give Up Date', extension: true },
]

export const AvailableFiltersTSDealers = [
  { id: 1, name: 'name', label: 'Name' },
  { id: 2, name: 'mc_number', label: 'MC Number' },
  { id: 3, name: 'owner_name', label: 'Company Owner' },
  { id: 4, name: 'company_type_id', label: 'Company Type' },
  { id: 5, name: 'address_state', label: 'State' },
  { id: 6, name: 'estimated_revenue', label: 'Est. Revenue' },
  { id: 7, name: 'date_established', label: 'Date Established' },
  { id: 8, name: 'created_by', label: 'Created By' },
  { id: 9, name: 'red_flag', label: 'Red Flag' },
  { id: 10, name: 'national_account', label: 'National Account' },
  {
    id: 11,
    name: 'related_national_account',
    label: 'Related National Account',
  },
  { id: 12, name: 'salesperson', label: 'Salesperson' },
  { id: 13, name: 'email', label: 'Email' },
  { id: 14, name: 'dot_number', label: 'Dot Number' },
  { id: 15, name: 'business_phone', label: 'Business Phone' },
  { id: 16, name: 'source_id', label: 'Source' },
  { id: 17, name: 'address_zip', label: 'Zip Code' },
  { id: 18, name: 'grade', label: 'Grade' },
  { id: 19, name: 'organization_type_id', label: 'Organization Type' },
  { id: 20, name: 'import_date', label: 'Import Date' },
  { id: 21, name: 'creation_date', label: 'Date Entered' },
  { id: 22, name: 'last_contact_date', label: 'Last Contact Date' },
  { id: 23, name: 'out_of_business', label: 'Out Of Business' },
  { id: 24, name: 'language', label: 'Language' },
]

export const AvailableFiltersFinanceDealers = [
  { id: 1, name: 'name', label: 'Name' },
  { id: 3, name: 'primary_contact', label: 'Primary Contact' },
  { id: 5, name: 'address_state', label: 'State' },
  { id: 6, name: 'estimated_revenue', label: 'Est. Revenue' },
  { id: 7, name: 'date_established', label: 'Date Established' },
  { id: 8, name: 'created_by', label: 'Created By' },
  { id: 9, name: 'red_flag', label: 'Red Flag' },
  { id: 12, name: 'salesperson', label: 'Salesperson' },
  { id: 13, name: 'email', label: 'Email' },
  { id: 15, name: 'business_phone', label: 'Business Phone' },
  { id: 16, name: 'source_id', label: 'Source' },
  { id: 17, name: 'address_zip', label: 'Zip Code' },
  { id: 18, name: 'grade', label: 'Grade' },
  { id: 19, name: 'dealership_type_id', label: 'Dealership Type' },
  { id: 21, name: 'creation_date', label: 'Date Entered' },
  { id: 22, name: 'last_contact_date', label: 'Last Contact Date' },
  { id: 11, name: `nationality_id`, label: 'Preferred Language' },
]

export const AvailableFiltersEmailTemplateContacts = [
  { id: 21, name: 'name', label: 'Name' },
  { id: 24, name: 'address_city', label: 'City' },
  { id: 1, name: 'address_state', label: 'State' },
  { id: 2, name: 'address_zip', label: 'Zip' },
  { id: 3, name: 'date_established', label: 'Date Established' },
  { id: 4, name: 'company_type_id', label: 'Company Type' },
  { id: 5, name: 'import_date', label: 'Import Date' },
  { id: 6, name: 'creation_date', label: 'Date Entered' },
  { id: 7, name: 'estimated_revenue', label: 'Estimated Revenue' },
  { id: 8, name: 'organization_type_id', label: 'Organization Type' },
  { id: 9, name: 'contact_effort_level', label: 'Effort Level' }, // contact_division => effort_level
  { id: 10, name: 'contact_category', label: 'Contact Type' },
  { id: 11, name: 'nationality_id', label: 'Preferred Language' },
  { id: 12, name: 'created_by', label: 'Created By' },
  { id: 13, name: 'source_id', label: 'Source' },
  { id: 14, name: 'contact_grade', label: 'Grade' }, // contact_division => grade
  { id: 15, name: 'contact_assigned', label: 'Assigned To' }, // contact_division => assigned
  { id: 16, name: 'contact_status', label: 'Status' }, // contact_division => status_id
  { id: 17, name: 'coverage_type', label: 'Coverage Type' },
  { id: 18, name: 'insurance_carrier', label: 'Insurance Carrier' },
  { id: 19, name: 'exp_date', label: 'Insurance Expiration' },
  { id: 20, name: 'is_ex_yu', label: 'Ex-Yu' },
  { id: 22, name: `number_of_trucks`, label: 'No. of Trucks' },
  { id: 23, name: `exclude_accounts`, label: 'Exclude Accounts' },
  { id: 25, name: 'cargo_carried', label: 'Cargo Carried' },
]
